module.exports = __webpack_public_path__ + "img/facebook_colored.1e80416a.svg";